module.exports = __webpack_public_path__ + "img/michelle-obama-small.24e9d0f8.jpg";